// extracted by mini-css-extract-plugin
export default {"slickArrow":"arrow_slickArrow__HvEA9","disabled":"arrow_disabled__3cYK8","left":"arrow_left__gdIyN"};